module.exports = __webpack_public_path__ + "img/kid3.18912c80.png";